import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { ReserveProvider } from "@/context/ReserveContext";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import Manifesto from "@/components/Manifesto";
import Inventory from "@/components/Inventory";
import SavingsCalculator from "@/components/SavingsCalculator";
import Showroom from "@/components/Showroom";
import Footer from "@/components/Footer";
import ReserveModal from "@/components/ReserveModal";
import AdminSync from "@/components/AdminSync";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen bg-ink text-white grid place-items-center p-8 text-center">
                    <div>
                        <h1 className="font-display text-2xl font-bold">Something went sideways.</h1>
                        <p className="mt-3 text-slate-400">Reload the page — or call the store and we'll handle it.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ReserveProvider>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <div className="grain min-h-screen bg-ink text-slate-50 font-sans">
                                    <Nav />
                                    <main>
                                        <Hero />
                                        <BrandMarquee />
                                        <Manifesto />
                                        <Inventory />
                                        <SavingsCalculator />
                                        <Showroom />
                                    </main>
                                    <Footer />
                                    <ReserveModal />
                                </div>
                            }
                        />
                        <Route path="/admin" element={<AdminSync />} />
                    </Routes>
                    <Toaster position="bottom-right" theme="dark" richColors />
                </ReserveProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
